import { useEffect, useState } from "react";
import type { CardState } from "../../hooks/use-session-state";
import type { LaidEntry } from "./types";
import { TileFront } from "./tile-front";
import { levelPct } from "../../hooks/use-session-state";

interface Props {
  entry: LaidEntry;
  rank: number;
  state: CardState;
  vacant: boolean;
  /** Bumped when a wash should run on this tile. */
  washToken: number;
  /** "known" or "unknown" — drives wash vs fail-feedback. */
  washMark: "known" | "unknown" | null;
  onClick: () => void;
}

export function Tile({
  entry,
  rank,
  state,
  vacant,
  washToken,
  washMark,
  onClick,
}: Props) {
  const [washing, setWashing] = useState(false);
  const [failing, setFailing] = useState(false);

  useEffect(() => {
    if (washToken === 0) return;
    if (washMark === "known") {
      // oxlint-disable-next-line react/set-state-in-effect -- triggered by the parent's washToken bump; auto-clears via setTimeout
      setWashing(true);
      const t = setTimeout(() => setWashing(false), 620);
      return () => clearTimeout(t);
    }
    if (washMark === "unknown") {
      setFailing(true);
      const t = setTimeout(() => setFailing(false), 340);
      return () => clearTimeout(t);
    }
  }, [washToken, washMark]);

  const density: "tiny" | "compact" | "full" =
    entry.w * entry.h < 1.5
      ? "tiny"
      : entry.w * entry.h < 5
        ? "compact"
        : "full";

  return (
    <button
      type="button"
      onClick={onClick}
      className="n5-tile border-rule focus-visible:ring-claimed absolute overflow-hidden border text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1"
      data-vacant={vacant}
      data-just-leveled={washing}
      data-just-failed={failing}
      data-density={density}
      aria-label={`${entry.display} — ${entry.gloss}`}
      style={{
        left: `${entry.x}%`,
        top: `${entry.y}%`,
        width: `${entry.w}%`,
        height: `${entry.h}%`,
        ["--level-pct" as string]: `${levelPct(state)}%`,
      }}
    >
      {!vacant && <TileFront entry={entry} rank={rank} density={density} />}
    </button>
  );
}
